import ReactTestUtils from 'react-dom/test-utils';
import deprecationTestkitLog from '../utils/deprecationTestkitLog';

const buttonDriverFactory = ({ element }) => {
  deprecationTestkitLog(
    'buttonTestkitFactory legacy testkit is deprecated and will be removed in next major release. Please use the ButtonTestkit unidriver testkit instead.',
  );

  return {
    exists: () => !!element,
    click: () => ReactTestUtils.Simulate.click(element),
    focus: () => ReactTestUtils.Simulate.focus(element),
    blur: () => ReactTestUtils.Simulate.blur(element),
    mouseEnter: () => ReactTestUtils.Simulate.mouseEnter(element),
    mouseLeave: () => ReactTestUtils.Simulate.mouseLeave(element),
    getButtonTextContent: () => element.textContent,
    isButtonDisabled: () => element.getAttribute('aria-disabled') === 'true',
    isPrefixIconExists: () => element.innerHTML.indexOf('prefix') !== -1,
    isSuffixIconExists: () => element.innerHTML.indexOf('suffix') !== -1,
  };
};

// For internal use only!
export default buttonDriverFactory;
